<template>
    <div class="kt-portlet kt-portlet--mobile">
        <!--begin::Form-->
        <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="kt-portlet__head kt-portlet__head--lg">
                <div class="kt-portlet__head-label">
                    <span class="kt-portlet__head-icon">
                        <i class="kt-font-brand flaticon-home"></i>
                    </span>
                    <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
                </div>
            </div>
            <div class="kt-portlet__body">
                <div class="kt-section kt-section--first">
                    <div class="row">
                        <!-- Begin:ระยะ Check-In/Check-Out — CR-PM-2026 R2.2 (label rename, ใช้ field เดียวกับ check-in + check-out)  -->
                        <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label class="label-required">ระยะ Check-In/Check-Out (เมตร) :</label>
                                <input id="msCheckInRange"
                                       name="msCheckInRange"
                                       type="number"
                                       min="1"
                                       max="10000"
                                       step="1"
                                       v-model.number="msCheckInRange"
                                       @input="checkMsCheckInRangeMax"
                                       @change="checkMsCheckInRangeMax"
                                       class="form-control"
                                       placeholder="M" />
                                <span v-if="msCheckInRangeMaxError" class="text-danger small">{{ msCheckInRangeMaxError }}</span>
                                <small class="form-text text-muted">
                                    การบันทึกจะอัพเดตระยะให้ทุก Master (ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อยและร้านค้าตัวแทนจำหน่าย/ร้านค้าตัวแทนจำหน่ายย่อย) ที่ตั้งเป็น "ใช้ตามตั้งค่าพื้นฐาน"
                                </small>
                            </div>
                        </div>
                        <!-- End:ระยะ Check-In/Check-Out -->
                    </div>
                </div>
            </div>

            <div class="kt-portlet__foot">
                <button type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="$router.go(-1)">
                    <i class="la la-close"></i> ย้อนกลับ
                </button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal">
                    <i class="la la-save"></i> บันทึกข้อมูล
                </button>
            </div>
        </form>
        <!--end::Form-->
    </div>
</template>

<script>
    import axios from "axios";
    import select2 from "../../../Shared/Select2";
    import Vue from "vue";
    import VueCurrencyInput from "vue-currency-input";
    import Vue2Filters from "vue2-filters";

    Vue.use(VueCurrencyInput);
    Vue.use(Vue2Filters);

    export default {
        components: {
            select2
        },
        data() {
            var self = this;
            return {
                msCheckInRange: null,
                msCheckInRangeMaxError: null
            };
        },
        computed: {
        },
        methods: {
            checkMsCheckInRangeMax(e) {
                const raw = e.target.value;
                const val = Number(raw);
                if (raw !== "" && !isNaN(val) && val > 10000) {
                    this.msCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
                    // Clamp value back to 10000 (block typing beyond)
                    this.msCheckInRange = 10000;
                    this.$nextTick(() => { if (e.target) e.target.value = 10000; });
                } else {
                    this.msCheckInRangeMaxError = null;
                }
            },
            formSubmit: function (e) {
                let router = this.$router;
                let self = this;

                if (
                    !$(this.$refs.form)
                        .validate()
                        .form()
                ) {
                    return false;
                }

                KTApp.blockPage({
                    opacity: 0.05,
                    message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                axios
                    .post("/Api/Setting", {
                        CheckInRange: self.msCheckInRange
                    })
                    .then(function (response) {
                        if (response.data.status) {
                            KTApp.unblockPage();
                            Swal.fire("สำเร็จ", response.data.message, "success").then(
                                // function () {
                                //     router.go(-1), self.$parent.reloadDataTable(false);
                                // }
                            );
                        } else {
                            //console.log(response);
                            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                        }
                    })
                    .catch(function (error) {
                        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                    })
                    .then(function () {
                        // always executed
                        KTApp.unblockPage();
                    });
            }
        },
        async mounted() {
            let self = this;

            $(this.$refs.form).validate({
                rules: {
                    msCheckInRange: "required"
                },
                messages: {
                    msCheckInRange: "กรุณาระบุระยะ Check-In"
                }
            });

            $(this.$refs.form).validate().settings.ignore = ":hidden";

            axios
                .get("/Api/Setting")
                .then(function (response) {
                    if (response.status == 200) {
                        self.msCheckInRange = response.data.checkInRange;
                    } else {
                        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบการตั้งค่าคุณเลือก", "warning");
                        router.go(-1);
                    }
                })
                .catch(function (error) {
                    Swal.fire(
                        "เกิดข้อผิดพลาด",
                        "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงการตั้งค่าได้ในขณะนี้",
                        "error"
                    );
                    router.go(-1);
                })
                .then(function () {
                    // always executed
                    KTApp.unblockPage();
                });
        }
    };
</script>


// WEBPACK FOOTER //
// App/Components/Master/Setting/ManageSetting.vue